import { useConfigContext } from 'contexts/config';
import { joinFiltersWithAnd } from 'lib/algolia';

type Props = {
  challengerFilter: string | false;
  contenderFilter: string | false;
  championFilter: string | false;
};

const buildFilterValue = (leaderboardFilter: string) =>
  joinFiltersWithAnd([leaderboardFilter, 'card_edition.name:blueprint']);
export const useEarlyAccessFilterValues = ({
  challengerFilter,
  contenderFilter,
  championFilter,
}: Props) => {
  const {
    so5: { competitionEligibilityAlgoliaFilters },
  } = useConfigContext();

  return {
    championFilterValue: championFilter
      ? buildFilterValue(competitionEligibilityAlgoliaFilters.Champion)
      : null,
    contenderFilterValue: contenderFilter
      ? buildFilterValue(competitionEligibilityAlgoliaFilters.Contender)
      : null,
    challengerFilterValue: challengerFilter
      ? buildFilterValue(competitionEligibilityAlgoliaFilters.Challenger)
      : null,
  };
};
